module.exports = {"labels":{"name":"Nome Fantasia","cnpj":"CNPJ","companyName":"Razão Social","doc":"Data de Constituição","foc":"Forma de Constituição","cnae":"CNAE Principal","registration":"Inscrição Municipal","income":"Faturamento médio mensal","pap":"Desejo aderir ao Ponto-a-Ponto"},"focList":[{"value":"SA","label":"S/A"},{"value":"LTDA","label":"LTDA"},{"value":"Simples","label":"Simples"},{"value":"Microempresa","label":"Microempresa"},{"value":"MEI","label":"MEI/Autônomo"}],"errorMessages":{"emptyField":"Campo obrigatório"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/EditCompanyDataForm/data.json
// module id = 1721
// module chunks = 0